interface NumberInputProps {
  value: number;
  onChange: (next: number) => void;
  min?: number;
  max?: number;
  step?: number;
  disabled?: boolean;
  label?: string;
}

export function NumberInput({
  value,
  onChange,
  min = 0,
  max = 10000,
  step = 1,
  disabled,
  label,
}: NumberInputProps) {
  return (
    <input
      type="number"
      aria-label={label}
      value={value}
      min={min}
      max={max}
      step={step}
      disabled={disabled}
      onChange={(e) => {
        const n = Number(e.target.value);
        if (Number.isFinite(n)) onChange(Math.min(Math.max(n, min), max));
      }}
      className="feluda-number-input"
    />
  );
}